import { Page } from '@/core/architecture'

import { ConsoleMissionCreateTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMissionCreate Page
 * Implemented as a practical sample.
 */
export const ConsoleMissionCreate: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMissionCreateTemplate state={state} {...actions} />
}
